module.exports = __webpack_public_path__ + "img/promotional_export_options.850a71a3.png";